module.exports = __webpack_public_path__ + "images/pan.png?1cba7c38e63661eb063e03e872989b3f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pan.png
// module id = 53
// module chunks = 0